// /user/getorder answers only a caller holding the order's uid or gallery sessionId.
// Every payment flow runs localStorage.clear() right before /payment-success/:oid,
// so checkout stashes both in sessionStorage — same tab, it survives that clear and
// the payment provider's redirects.
const UID_KEY = "orderAccessUid";
const SID_KEY = "orderAccessSid";

const read = (store, key) => {
  try {
    return store.getItem(key) || "";
  } catch (e) {
    return "";
  }
};

// Call where the order is created/paid, while localStorage still has the cart ids.
export function rememberOrderAccess() {
  try {
    const uid = localStorage.getItem("uniqueUserId");
    const sid = localStorage.getItem("sessionId");
    if (uid) sessionStorage.setItem(UID_KEY, uid);
    if (sid) sessionStorage.setItem(SID_KEY, sid);
  } catch (e) {
    // Storage blocked: the success page shows its plain thank-you instead.
  }
}

// Query params for /user/getorder: the checkout's stash first (the ids this order
// was made with), then live localStorage (clear not run yet), then the wall's mirror.
export function orderAccessParams() {
  return {
    uid: read(sessionStorage, UID_KEY) || read(localStorage, "uniqueUserId") || read(sessionStorage, "wallUid"),
    sessionId: read(sessionStorage, SID_KEY) || read(localStorage, "sessionId") || read(sessionStorage, "wallSid"),
  };
}
